import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import OutbOrd02ProcessActions, { OutbOrd02ProcessTypes } from '../Stores/OutbOrd02Process/Actions';

const getAppStore = state => state.app;

export function* outbOrd02ProcessFetchProcess() {
  // match original name
  try {
    yield put(OutbOrd02ProcessActions.outbOrd02ProcessFetchProcessLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi,
      app.apiUrl,
      `division/indexSalesFlow/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      yield put(OutbOrd02ProcessActions.outbOrd02ProcessFetchProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd02ProcessActions.outbOrd02ProcessFetchProcessLoading(false));
  }
}

export const saga = [
  takeLatest(OutbOrd02ProcessTypes.OUTB_ORD02_PROCESS_FETCH_PROCESS, outbOrd02ProcessFetchProcess)
];
